import { StyleSheet, Image } from 'react-native'
import { DS } from '../../../design-system'
import { fontFamily } from '../../../theme'
import { LessonChapterProgressModelType } from '../../../models/api-store'

export const Overview = ({ data }: { data?: LessonChapterProgressModelType }) => {
  if (!data) return null

  return (
    <DS.Frame style={styles.container} gap="16">
      <DS.Frame style={styles.section}>
        <DS.Frame>
          <DS.Text variant="Heading 4/Medium" style={styles.skillTitle}>
            Skills Covered
          </DS.Text>
        </DS.Frame>
        <DS.Frame style={styles.skillList}>
          {data.skills?.map((x) => (
            <DS.Frame key={x} style={styles.skillItemContainer}>
              <DS.Icon name="Check" size={16} color="Global/Black" />
              <DS.Text variant="Body Medium/Regular" style={styles.skillItem}>
                {x}
              </DS.Text>
            </DS.Frame>
          ))}
        </DS.Frame>

        <DS.Frame style={styles.separator} />

        <DS.Frame gap="16">
          <DS.Frame>
            <DS.Text variant="Body Medium/Regular" style={styles.descriptionSkill}>
              {data.description}
            </DS.Text>
          </DS.Frame>
          <DS.Frame row gap="12">
            <DS.Text variant="Body Small/Medium">Course Duration</DS.Text>
            <DS.Text variant="Body Small/Regular">{data.duration}</DS.Text>
          </DS.Frame>
        </DS.Frame>
      </DS.Frame>

      <DS.Frame style={styles.section}>
        <DS.Frame row gap="16">
          <DS.Frame>
            <Image source={{ uri: data.teacher?.image }} style={styles.avatar} />
          </DS.Frame>
          <DS.Frame>
            <DS.Text variant="Heading 4/Medium">{data.teacher?.name}</DS.Text>
            <DS.Text variant="Body Small/Regular" style={styles.teacherRole}>
              {data.teacher?.role}
            </DS.Text>
          </DS.Frame>
        </DS.Frame>

        <DS.Frame style={styles.separator} />

        <DS.Frame row gap="16">
          <DS.Frame>
            <DS.Icon name="Quotation" size={24} color="Global/Black" />
          </DS.Frame>
          <DS.Frame style={styles.descriptionTeacher}>
            <DS.Text variant="Body Small/Regular">{data.teacher?.statement}</DS.Text>
          </DS.Frame>
        </DS.Frame>
      </DS.Frame>
    </DS.Frame>
  )
}

const styles = StyleSheet.create({
  scrollViewContent: {
    flexGrow: 1,
    paddingBottom: 16
  },
  container: {
    marginHorizontal: 24
  },
  section: {
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
    padding: 16,
    borderRadius: 12,
    gap: 16
  },
  skillTitle: {
    fontSize: 22,
    fontFamily: fontFamily.FeatureDeckRegular
  },
  skillList: {
    flexDirection: 'row',
    flexWrap: 'wrap'
  },
  skillItemContainer: {
    width: '50%',
    marginBottom: 8,
    flexDirection: 'row',
    gap: 4
  },
  skillItem: {
    fontFamily: fontFamily.GTAmericaStandardRegular,
    fontSize: 16
  },
  separator: {
    backgroundColor: DS.palette['Brand/Light Grey'],
    width: '100%',
    height: 1
  },
  descriptionSkill: {
    fontFamily: fontFamily.GTAmericaStandardRegular,
    fontSize: 16,
    letterSpacing: -0.25
  },
  teacherRole: {
    fontFamily: fontFamily.GTAmericaStandardRegular
  },
  descriptionTeacher: {
    flexShrink: 1
  },
  avatar: {
    width: 72,
    height: 72,
    borderRadius: 100,
    backgroundColor: '#fff',
    shadowColor: 'rgba(0, 0, 0, 0.1)',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 1,
    shadowRadius: 8
  }
})
